<app-kpi-widget
  [title]="'driverOverview.widgets.driverPerformance' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-star'"
  [totalValue]="value"
  [percentageDifference]="percentageDifference"
  [difference]="difference"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [differenceFormatter]="formatDifference.bind(this)"
  (clicked)="openPerformanceModal()"
  [isImageIcon]="false"
  [widgetDisabled]="false"
  [hasFooter]="false"
  [dropdownEnabled]="false">
</app-kpi-widget>